import React from 'react'
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import LoginTile from './LoginTile';
import Cookies from 'js-cookie';


function VoteTile({ collectionGroupId, documentId, documentSubject, sendValueBack }) {

    const navigate = useNavigate();
    const [userVote, setUserVote] = useState({});
    const [loggedIn, setLoggedIn] = useState(false);

    const getUsersLikeDislike = async () => {
        axios
            .get("/api/v1/uservote/myvote/" + collectionGroupId + "/" + documentId)
            .then((result) => {
                setUserVote(result.data);
            })
            .catch((err) => setUserVote({ noresult: true }));
    }



    const deleteVote = async () => {
        axios
            .delete("/api/v1/uservote/" + userVote.id)
            .then((result) => {
                setUserVote({ noresult: true })
                sendVoteBack(documentId);
            })
            .catch((err) => console.log(err));
    };

    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showLoginWindow, setShowLoginWindow] = useState(false);

    const handleLoginTileReturn = (sts) => {
        getUsersLikeDislike();
        setShowLoginWindow(false);
    }


    const sendVoteBack = (a) => {
        if (sendValueBack) {
            sendValueBack(a);
        }
    }

    const addVote = async (updown) => {

        if (!loggedIn) {
            setShowErrorMessage(true);
        } else {
            let payload = {
                collectionGroupId: collectionGroupId,
                documentId: documentId,
                likesit: updown,
            };

            axios
                .post("/api/v1/uservote", payload)
                .then((result) => {
                    setUserVote(result.data);
                    sendVoteBack(documentId);
                })
                .catch((err) => console.log(err));
        }
    }

    const getUserName = () => {
        const user = Cookies.get('username');
        if (user) {
            setLoggedIn(true);
        } else {
            setLoggedIn(false);
        }
    }

    useEffect(() => {
        getUsersLikeDislike();
        getUserName();
    }, []);

    return (
        <div>
            {collectionGroupId == 1 &&
                <div>
                    {userVote.noresult &&
                        <p>Do you agree&nbsp;
                            <img src="/graphics/icons/hand-thumbs-up.svg" alt="like" onClick={() => addVote(true)} />
                            &nbsp;  or disagree &nbsp;
                            <img src="/graphics/icons/hand-thumbs-down.svg" alt="dislike" onClick={() => addVote(false)} />
                            &nbsp; with this {documentSubject}?</p>
                    }
                    {(userVote.likesit === true || userVote.likesit === false) &&
                        <div>
                            You previously voted &nbsp;
                            <img style={{ display: userVote.likesit ? "" : "none" }} src="/graphics/icons/hand-thumbs-up.svg" alt="like" onClick={() => deleteVote()} />
                            <img style={{ display: !userVote.likesit ? "" : "none" }} src="/graphics/icons/hand-thumbs-down.svg" alt="like" onClick={() => deleteVote()} />

                            &nbsp;. Click again to change your vote.
                        </div>
                    }
                </div>
            }
            {(collectionGroupId == 30 || collectionGroupId == 40) &&
                <div>
                    {userVote.noresult &&
                        <p>
                            <img src="/graphics/icons/hand-thumbs-up.svg" alt="like" onClick={() => addVote(true)} /> &nbsp; Vote for this candidate
                        </p>
                    }
                    {(userVote.likesit === true || userVote.likesit === false) &&
                        <div>
                            You voted for this candidate. &nbsp;
                            <img style={{ display: userVote.likesit ? "" : "none" }} src="/graphics/icons/hand-thumbs-up.svg" alt="like" onClick={() => deleteVote()} />
                            &nbsp; Click again to remove.
                        </div>
                    }
                </div>
            }


            {showErrorMessage && (
                <div className="overlay">
                    <div className="popup">
                        <h3>Error</h3>
                        <p>Only registered users can contribute to the debate.</p>
                        <div className="header-link">
                            <div onClick={() => navigate("/Register.html")}>Register</div>
                            <div onClick={() => { setShowErrorMessage(false); setShowLoginWindow(true) }}>Login</div>
                            <button onClick={() => setShowErrorMessage(false)}>Ok</button>
                        </div>
                    </div>
                </div>
            )}
            {showLoginWindow && (
                <LoginTile sendValueBack={handleLoginTileReturn} />
            )}

        </div>
    )
}

export default VoteTile
